import './SdoAdminReportInfo.scss';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getEasternTime, getMonthDayYear, getTimeHrMin } from '../../helpers/dateHelpers';
import CountdownTimer from '../CountdownTimer/CountdownTimer';
import HorizontalProgressBar from '../HorizontalProgressBar/HorizontalProgressBar';
import { submissionReportStatus,infoTabStatus, getMonthNday, getHourNminute } from '../SpecialDayOff/SpecialDayOffHelper';
import { useSdoAdminReportsProvider } from '../../providers/SdoAdminReportsProvider';
import { CurrentSubPeriod } from '../../models/SdoInterface';
import Loader from '../Loader/Loader';
import { months } from '../../constants/dates';

export default function SdoAdminReportInfo() {
    const { t } = useTranslation();
    const sdoAdminReportsContext = useSdoAdminReportsProvider();
    const [sdoCurrentSubPeriod, setSdoCurrentSubPeriod] = useState<CurrentSubPeriod>();
    const [sdoMonthYear, setSdoMonthYear] = useState("");
    const [sdoStatus, setSdoStatus] = useState("");
    const [eipPublishedDate, setEipPublishedDate] = useState<Date | string | any>('');    

    useEffect(() => {
        if (!sdoAdminReportsContext || !sdoAdminReportsContext?.sdoCurrentSubPeriodData) return;
        setSdoCurrentSubPeriod(sdoAdminReportsContext.sdoCurrentSubPeriodData);
        setSdoMonthYear(months[Number(sdoAdminReportsContext?.sdoCurrentSubPeriodData?.month)-1]+" "+sdoAdminReportsContext?.sdoCurrentSubPeriodData?.year);
        setSdoStatus(sdoAdminReportsContext?.sdoCurrentSubPeriodData?.status);
        setEipPublishedDate(sdoAdminReportsContext?.sdoCurrentSubPeriodData?.eipDeliveredDate);
        getPositionTrackerValue();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sdoAdminReportsContext.sdoCurrentSubPeriodData]);

    const submissionReportContent = { status: '', statusClass: '' };

    const getPositionTrackerValue = () => {
        if(!sdoCurrentSubPeriod?.positionsPublishedTotal || !sdoCurrentSubPeriod?.positionsPublished ) return 0;
        return Math.round((sdoCurrentSubPeriod?.positionsPublished / sdoCurrentSubPeriod?.positionsPublishedTotal) * 100);
    }

    const getSubmissionReportStatus = (status) => {
        switch (status) {
            case (submissionReportStatus.OPEN):
                submissionReportContent.status = infoTabStatus.open;
                submissionReportContent.statusClass = 'sdo-admin-report__status-open';
                break;
            case (submissionReportStatus.CLOSED):
                submissionReportContent.status = infoTabStatus.closed;
                submissionReportContent.statusClass = 'sdo-admin-report__status-closed';
                break;
            case (submissionReportStatus.OVERDUE):
                submissionReportContent.status = infoTabStatus.overDue;
                submissionReportContent.statusClass = 'sdo-admin-report__status-overdue';
                break;
            default:
                submissionReportContent.status = '';
                submissionReportContent.statusClass = '';
                break;
        }
    }

    if(!sdoAdminReportsContext.sdoCurrentSubPeriodLoading) {
        getSubmissionReportStatus(sdoStatus);
    }

    return (
        sdoAdminReportsContext.sdoCurrentSubPeriodLoading ? <Loader /> : (
        <div className='sdo-admin-report__container'>
            <div className='sdo-admin-report__header-cntr'>
                <div className='sdo-admin-report__sdo-period-cntr'>
                    <p className='sdo-admin-report__sdo-period-title'>{t('specialDayOffAdmin.sdoAdminReportInfo.submissionPeriod')}</p>
                    <div className='sdo-admin-report__sdo-period-content'>
                        <p className='sdo-admin-report__sdo-period--month-year'>{sdoMonthYear}</p>
                        <div className={`sdo-admin-report__sdo-period-status ${submissionReportContent.statusClass}`}>{submissionReportContent.status}</div>
                    </div>
                </div>
                {sdoStatus === submissionReportStatus.OVERDUE || (sdoStatus === submissionReportStatus.CLOSED && (sdoCurrentSubPeriod?.positionsPublished !== sdoCurrentSubPeriod?.positionsPublishedTotal)) ? 
                    <div className='sdo-admin-report__next-submission-cntr'>
                        <p className='sdo-admin-report__next-submission-text'>{t('specialDayOffAdmin.sdoAdminReportInfo.nextSubmission')}</p>
                        <p className='sdo-admin-report__next-submission-timer'> <CountdownTimer biddingClosedWithTime={getEasternTime(sdoCurrentSubPeriod?.nextSubmissionPeriod)} sdoAdminReport={true} /></p>
                    </div> : ''}
                <Button className='sdo-requests__submission-request-button'><Link to="/sdo-admin-report-details">{t('specialDayOffAdmin.sdoAdminReportInfo.sdoRequests')}</Link></Button>               
            </div>
            <div className='sdo-admin-report__second-cntr'>
                {sdoStatus === submissionReportStatus.OPEN ?
                    <>

                        <div className='sdo-admin-report__stats-header'>
                            <p className='sdo-admin-report__stats-text'>{t('specialDayOffAdmin.sdoAdminReportInfo.pendingRequest')}</p>
                            <p className='sdo-admin-report__stats-pending-request'>{sdoCurrentSubPeriod?.pendingRequests ?? 0}</p>
                        </div>
                        <span className="sdo-admin-report__stats__section-divider" />
                        <div className='sdo-admin-report__stats-header'>
                            <p className='sdo-admin-report__stats-text'>{t('specialDayOffAdmin.sdoAdminReportInfo.pendingApproval')}</p>
                            <p className='sdo-admin-report__stats-pending-approval'>{sdoCurrentSubPeriod?.pendingApproval ?? 0}</p>
                        </div>
                        <span className="sdo-admin-report__stats__section-divider" />
                        <div className='sdo-admin-report__stats-header'>
                            <p className='sdo-admin-report__stats-text'>{t('specialDayOffAdmin.sdoAdminReportInfo.pendingDecline')}</p>
                            <p className='sdo-admin-report__stats-pending-decline'>{sdoCurrentSubPeriod?.pendingDecline ?? 0}</p>
                        </div>
                        <span className="sdo-admin-report__stats__section-divider" />
                        <div className='sdo-admin-report__stats-header'>
                            <p className='sdo-admin-report__stats-text'>{t('specialDayOffAdmin.sdoAdminReportInfo.submissionCloses')}</p>
                            <p className='sdo-admin-report__stats-submission-closes-result'>{getMonthNday(getEasternTime(sdoCurrentSubPeriod?.submissionCloses))} {getHourNminute(getEasternTime(sdoCurrentSubPeriod?.submissionCloses))}</p>
                        </div>
                        <span className="sdo-admin-report__stats__section-divider" />

                    </>
                    :
                    <>
                        <div className='sdo-admin-report__position-tracker-header'>
                            <HorizontalProgressBar height={14} value={getPositionTrackerValue()} />
                            <span className='sdo-admin-report__position-tracker-text'>
                                <p className='sdo-admin-report__position-tracker-text1'>{sdoCurrentSubPeriod?.positionsPublished ?? 0}</p>
                                <p className='sdo-admin-report__position-tracker-text2'>
                                    {t('specialDayOffAdmin.sdoAdminReportInfo.publishedPosition', { totalPosition2: sdoCurrentSubPeriod?.positionsPublishedTotal ?? 0})}
                                </p>
                            </span>
                            {eipPublishedDate && eipPublishedDate.length ? <p className='sdo-admin-report__position-text-two'> {t('specialDayOffAdmin.sdoAdminReportInfo.deliveryDate', { deliveryDate: `${getMonthDayYear(getEasternTime(sdoCurrentSubPeriod?.eipDeliveredDate))} ${getTimeHrMin(getEasternTime(sdoCurrentSubPeriod?.eipDeliveredDate))}` })}</p> :''}
                        </div>
                        <div className='sdo-admin-report__stats-header'>
                            <p className='sdo-admin-report__stats-text'>{t('specialDayOffAdmin.sdoAdminReportInfo.request')}</p>
                            <p className='sdo-admin-report__stats-pending-request'>{sdoCurrentSubPeriod?.requests ?? 0}</p>
                        </div>
                        <span className="sdo-admin-report__stats__section-divider-two" />
                        <div className='sdo-admin-report__stats-header'>
                            <p className='sdo-admin-report__stats-text'>{t('specialDayOffAdmin.sdoAdminReportInfo.approved')}</p>
                            <p className='sdo-admin-report__stats-pending-approval'>{sdoCurrentSubPeriod?.approved ?? 0}</p>
                        </div>
                        <span className="sdo-admin-report__stats__section-divider-two" />
                        <div className='sdo-admin-report__stats-header'>
                            <p className='sdo-admin-report__stats-text'>{t('specialDayOffAdmin.sdoAdminReportInfo.decline')}</p>
                            <p className='sdo-admin-report__stats-pending-decline'>{sdoCurrentSubPeriod?.declined ?? 0}</p>
                        </div>
                        <span className="sdo-admin-report__stats__section-divider-two" />
                    </>
                }
                <div className='sdo-admin-report__stats-header'>
                    <p className='sdo-admin-report__stats-text'>{t('specialDayOffAdmin.sdoAdminReportInfo.result')}</p>
                    <p className='sdo-admin-report__stats-submission-closes-result'>{getMonthNday(getEasternTime(sdoCurrentSubPeriod?.resultsBy))} {getHourNminute(getEasternTime(sdoCurrentSubPeriod?.resultsBy))}</p>
                </div>
            </div>
        </div >
        )
    )
}